import { useNavigation } from '@react-navigation/native';
import { View, SxProp, useDripsyTheme } from 'dripsy';
import { RootStackParamList, RootStackRoutes, RootTabParamList } from 'types';
import { EarnStackParamList, EarnStackRoutes, EarnTabParamList, EarnTabRoutes } from '../../earn.navigator';
import { SVGIconList } from '@/design-system/components/icons/Icon';
import { SegmentSelect, SegmentSelectItem } from '@/design-system/components/buttons/segmentSelect/SegmentSelect';
export interface NavigationData {
  title: string;
  toPage: keyof RootStackParamList | keyof RootTabParamList | keyof EarnStackParamList | keyof EarnTabParamList;
  icon?: SVGIconList;
}

interface PageNavigationProps<T> {
  data: Array<SegmentSelectItem<T>>;
  currentPage?: T;
  sx?: SxProp;
}

export const PageNavigation = <T extends unknown>({ data, currentPage, sx }: PageNavigationProps<T>) => {
  const navigation = useNavigation();
  const { theme } = useDripsyTheme();

  return (
    <View sx={{ ...styles.container, ...sx }}>
      <SegmentSelect
        key="overview-page-item-header-suffix-0"
        data={data}
        value={currentPage}
        onValueChange={(item) =>
          navigation.navigate(RootStackRoutes.Earn, {
            screen: EarnStackRoutes.Main,
            params: {
              screen: item
            }
          })
        }
        wrapperBackgroundColor="#FFFFFF"
        buttonWidth={124}
        buttonHeight={44}
        buttonBackgroundColors={theme?.linearGradients?.SegmentSelectActive}
        labelColorActive="#FFFFFF"
        labelColorInactive="#4D4D4D"
      />
    </View>
  );
};

enum StyleName {
  container = 'container'
}

const styles: Record<StyleName, SxProp> = {
  container: {
    mt: '$5',
    flexDirection: 'row',
    gap: '$7'
  }
};
